import AdjustOutlined from "@mui/icons-material/AdjustOutlined";
import CheckCircleOutlineRounded from "@mui/icons-material/CheckCircleOutlineRounded";
import ErrorOutlineRounded from "@mui/icons-material/ErrorOutlineRounded";
import RadioButtonChecked from "@mui/icons-material/RadioButtonChecked";
import { Skeleton } from "@mui/material";
import { SubmissionStepState } from "hooks/useSubmissionSteps";

export const SubmissionStepStatusIcon = ({ status }: { status?: SubmissionStepState }) => {
  switch (status) {
    case SubmissionStepState.NotStarted:
      return <AdjustOutlined color="action" />;
    case SubmissionStepState.InProgress:
      return <RadioButtonChecked color="primary" />;
    case SubmissionStepState.Done:
      return <CheckCircleOutlineRounded color="success" />;
    case SubmissionStepState.Invalid:
      return <ErrorOutlineRounded color="error" />;
    case undefined:
      return <Skeleton variant="circular" width={20} height={20} />;
    default:
      ((_: never) => {
        throw new Error(`Unexpected value: ${_}`);
      })(status);
  }
};
